import { g as getDB, m as magicLink, u as user } from "../../../chunks/index3.js";
import { s as sendVerificationMail } from "../../../chunks/index5.js";
import { customAlphabet } from "nanoid";
import { eq } from "drizzle-orm";
import { fail, redirect, error } from "@sveltejs/kit";
import { i as invalidateSession, d as deleteSessionTokenCookie } from "../../../chunks/auth.js";
import { l as valibot, L as LoginMailSchema } from "../../../chunks/valibot.js";
import "clsx";
import "@sveltejs/kit/internal";
import "../../../chunks/exports.js";
import "../../../chunks/utils.js";
import "../../../chunks/client2.js";
import "ts-deepmerge";
import "../../../chunks/formData.js";
import { s as superValidate, m as message } from "../../../chunks/superValidate.js";
import "memoize-weak";
import "zod-to-json-schema";
import { a as isAllowedEmail, b as createUUID } from "../../../chunks/auth.server.js";
import { H as HOUR_IN_MS } from "../../../chunks/defaults.js";
import { l as localizeHref } from "../../../chunks/runtime.js";
import { i as invalid_email_not_allowed } from "../../../chunks/invalid_email_not_allowed.js";
const nanokey = customAlphabet("abcdefghijkmnpqrstuvwxyz23456789", 3);
const getUserId = async (email, userId) => {
  const db = getDB();
  const user$1 = await db.select({ id: user.id }).from(user).where(eq(user.email, email.toLowerCase())).get();
  if (user$1) {
    return user$1.id;
  } else if (userId) {
    await db.update(user).set({ email: email.toLowerCase() }).where(eq(user.id, userId)).run();
    return userId;
  } else {
    const id = createUUID();
    await db.insert(user).values([
      {
        id,
        temp: true,
        email: email.toLowerCase(),
        createdAt: /* @__PURE__ */ new Date(),
        lastSeen: /* @__PURE__ */ new Date()
      }
    ]).run();
    return id;
  }
};
const actions = {
  mail: async ({ request, locals }) => {
    const db = getDB();
    const form = await superValidate(request, valibot(LoginMailSchema));
    if (!form.valid) {
      return fail(400, { form });
    }
    const { email, theme } = form.data;
    if (!isAllowedEmail(email)) {
      return message(form, invalid_email_not_allowed(), { status: 400 });
    }
    const userId = await getUserId(email, locals.user?.id);
    const magicid = createUUID();
    const verification = nanokey();
    await db.insert(magicLink).values([
      {
        id: magicid,
        userId,
        expiresAt: new Date(Date.now() + HOUR_IN_MS),
        verification,
        email
      }
    ]).run();
    try {
      await sendVerificationMail(email, verification, theme);
    } catch (e) {
      console.error(e);
      error(500);
    }
    redirect(302, localizeHref(`/login/${magicid}`));
  },
  logout: async (event) => {
    if (!event.locals.session) {
      return fail(401);
    }
    await invalidateSession(event.locals.session.id);
    deleteSessionTokenCookie(event);
    return redirect(302, localizeHref("/"));
  }
};
export {
  actions
};
